<script setup lang="ts">
    import { BUTTON_CLASSES } from '@/config.components';
    import { computed } from 'vue';

    const {
        dataTest = 'button-base',
        defaultClasses = true,
        disabled = false,
        disableHover = false,
        stick = undefined,
        submit = false,
        variant = 'outlined',
    } = defineProps<{
        dataTest?: string;
        defaultClasses?: boolean;
        disabled?: boolean;
        disableHover?: boolean;
        stick?: keyof (typeof BUTTON_CLASSES)['stick'];
        submit?: boolean;
        variant?: 'filled' | 'outlined' | 'text';
    }>();

    const buttonType = computed(() => (submit ? 'submit' : 'button'));

    const buttonClass = computed(() =>
        [
            ...(defaultClasses ? BUTTON_CLASSES.common : []),
            ...(disabled ? BUTTON_CLASSES.disabled : []),
            ...(stick ? BUTTON_CLASSES.stick[stick] : []),
            ...Object.values(BUTTON_CLASSES.types[variant]),
        ].join(' '),
    );
</script>

<template>
    <button
        :data-no-hover="disableHover"
        :class="[buttonClass, $attrs.class]"
        :type="buttonType"
        :disabled
        :data-test
        v-bind="$attrs"
    >
        <slot>Button</slot>
    </button>
</template>
